import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id B3E07750-AF3A-49FA-BA72-7CE5D4A3C7AB
 * name view-array
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-array.svg
 * tags
 * - View 
 */
export const ViewArrayIcon = createSvgIcon(<><path d="M8,18H17V5H8M18,5V18H21V5M4,18H7V5H4V18Z" /></>, 'ViewArrayIcon');
export default ViewArrayIcon